import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import SimplePageTemplate from './SimplePageTemplate';
import Error from './Error';

const StaticPage = props => (
  <SimplePageTemplate
    title={props.data.title || trans('error_page.client_error.title')}
    locales={props.locales}
    trackingPrefix="ga-static"
  >
    {props.data.content ? (
      <div dangerouslySetInnerHTML={{ __html: props.data.content }} />
    ) : (
      <Error />
    )}
  </SimplePageTemplate>
);

StaticPage.getDefaultProps = {
  locales: {}
};

StaticPage.propTypes = {
  data: PropTypes.object.isRequired,
  locales: PropTypes.object
};

export default StaticPage;
